import React, { useState, useEffect } from 'react'
import Header from "../../components/Header/Header.jsx";
import { getMisPagos, getCuponPDF } from "../../core/misPagos/misPagos-actions.js";
import { withStyles } from '@material-ui/core/styles';
import pagesStyle from "../../components/Page/PageStyle";
import { useSelector, useDispatch } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardBody from "../../components/Card/CardBody.jsx";
import BlockComponent from "../../components/Loading/BlockComponent";
import Grid from "@material-ui/core/Grid";
import CardHeader from "../../components/Card/CardHeader.jsx";

import Dialog from '@material-ui/core/Dialog';
import moment from "moment";
import {downloadFile} from "../../core/downloadService";
import ComprobantePago from "../../components/ComprobantePago/ComprobantePago.jsx";
import ListadoPagos from "./ListadoPagos.jsx";

const styles = (theme) => ({
	...pagesStyle(theme),
});

const MisPagos = (props) => {

  const [message, setMessage] = useState({
    message: null,
    messageColor: null
  });
  const [openComprobante, setOpenComprobante] = useState(false);
  const [selectedComprobante, setSelectedComprobante] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => {
    return state.auth.user;
  });
  const misPagos = useSelector((state) => {
    return state.misPagos;
  });
  const parametros = useSelector((state) => {
    return state.parametros.data;
  });
  const { classes, headerProps } = props;
  const loading = misPagos.loadingMisPagos;

  const messageHelper = {
    resetMessage: () => {
      setMessage({message: null, messageColor: null});
    },
    setMessage: ({message, messageColor}) => {
      setMessage({message, messageColor})
      setTimeout(messageHelper.resetMessage, 6000);
    },
    setErrorMessage: (message) => {
      messageHelper.setMessage({ message, messageColor: 'danger' })
    },
  };

	useEffect(() => {
		const params = {
      usuario: user.id,
    };
		Promise.resolve(
			dispatch(getMisPagos(params))
		).catch((error)=>{
			messageHelper.setErrorMessage(error.message);
		})
	}, []);

	const verComprobante = (comprobante) => {
    setSelectedComprobante(comprobante);
		setOpenComprobante(true);
	};

	const handleCloseModal = () => {
    setOpenComprobante(false);
	};

	const handleDescargar = (idOperacion) => {
		Promise.resolve(
			dispatch(getCuponPDF({idOperacion}))
		).then(comprobante =>{
			downloadFile(comprobante, "cuponPago", "pdf");
		}).catch(error => messageHelper.setErrorMessage(error.message))
	}


  return (
  <BlockComponent blocking={loading}>
    <Header {...headerProps} showTitle={true}>
    </Header>
    <div className={classes.wrapper}>
      <Dialog fullWidth onClose={handleCloseModal} aria-labelledby="customized-dialog-title" open={openComprobante}>
        <div style={{margin:'10px'}}>
          {
            selectedComprobante &&
            <Grid container justify="center">
              <Grid item xs={12}>
                <ComprobantePago
                  titulo={(parametros.AU_NOMBRE_MUNICIPIO && parametros.AU_NOMBRE_MUNICIPIO.valor) || 'Oficina Virtual'}
                  fecha={moment(new Date(selectedComprobante.fecha), 'YYYY-MM-DD HH:MM:SS').format('DD/MM/YYYY')}
                  hora={selectedComprobante.fecha.substr(11,18)}
                  transaccion={selectedComprobante.nro_operacion}
                  usuario={user.nombre}
                  importe={selectedComprobante.monto}
                  fechaActualizacion={selectedComprobante.fechaActualizacion}
                  medioPago={selectedComprobante.medio_pago}
                  estado={selectedComprobante.estado}
                  user_message={selectedComprobante.user_message}
                />
              </Grid>
            </Grid>
          }
        </div>
      </Dialog>

    <Grid container >
      <Grid item xs={12}>
      <Card className={classes.card}>
        <CardHeader>

        </CardHeader>
        <CardBody>
          <ListadoPagos
            data={misPagos.data}
            onClickVerComprobante={verComprobante}
            download={handleDescargar}
          />
        </CardBody>
      </Card>
      </Grid>
    </Grid>
    </div>
  </BlockComponent>
  )
};

export default (withStyles(styles)(MisPagos));
